module.exports = __webpack_public_path__ + "static/computer-labels-328bc1057c98807d47cd18bc29cf00e2.png";